import * as React from "react"
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible"
import { ChevronDown } from "lucide-react"

import { cn } from "@/lib/core/utils"

const Collapsible = CollapsiblePrimitive.Root

const CollapsibleTrigger = React.forwardRef<
  React.ElementRef<typeof CollapsiblePrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof CollapsiblePrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <CollapsiblePrimitive.Trigger
    ref={ref}
    className={cn("group/collapse", className)}
    {...props}
  />
))
CollapsibleTrigger.displayName = CollapsiblePrimitive.Trigger.displayName

const CollapsibleContent = CollapsiblePrimitive.Content

/** Closed points down. Open rotates 180°. Pass `open` outside a CollapsibleTrigger. */
function CollapseChevron({
  open,
  className,
}: {
  open?: boolean
  className?: string
}) {
  return (
    <ChevronDown
      aria-hidden
      className={cn(
        "h-4 w-4 shrink-0 text-muted-foreground transition-transform duration-200",
        open === undefined
          ? "group-data-[state=open]/collapse:rotate-180"
          : open && "rotate-180",
        className,
      )}
    />
  )
}

export { Collapsible, CollapsibleTrigger, CollapsibleContent, CollapseChevron }
